import React, {useEffect} from 'react'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import * as actions from '~/store/actions'
import Loading from './Loading'

const Logout = ({ logout }) => {

  useEffect(() => {
    void logout();

  }, []);

  return <Loading loading />;
};

const mapStateToProps = state => {
  return { ...state.authenticationReducer, ...state.userSource }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(actions.logout()),
    setAuthenticationRedirectPath: (path = '/') => {
      return dispatch(actions.setAuthenticationRedirectPath(path))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout))
